<template>
  <v-dialog  persistent v-model="bindAppDialogCtl" width="600">
    <v-card width="100%" height="490" >
      <div style="width: 100%;height: 70px;display: flex">
        <div style="font-size: 20px;line-height: 70px;color: black;margin-left: 40px">账号绑定</div>
        <v-spacer></v-spacer>
        <span @click="closeBindAppDialog" class="iconfontFamily" style="font-size: 10px;color: rgba(166, 166, 166, 1);line-height: 70px;margin-right: 30px;cursor: pointer">&#xe60d;</span>
      </div>
      <v-divider style="box-shadow: 0 2px 7px 0 #3FA6A6A6;"></v-divider>
      <div style="font-size: 16px;color: black;margin: 55px auto 0 auto;width: fit-content">请通过共生地球app扫描下方二位码进行绑定</div>
      <div  style="position: relative;width: 180px;height: 180px;margin: 55px auto 0 auto">
        <!--二维码-->
        <div ref="qrCode" style="width: 180px;height: 180px;position: absolute;"></div>
        <!--扫码成功蒙层-->
        <div v-show="scanSuccess" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
          <div style="width: max-content;height: 40px">
            <span class="iconfontFamily" style="font-size: 40px;color: rgba(67, 207, 124, 1);float: left;line-height: 40px">&#xe602;</span>     <div style="font-size: 20px;color: rgba(67, 207, 124, 1);line-height: 40px;float: left;margin-left: 5px">扫码成功</div>
          </div>
        </div>
        <!--二维码失效蒙层-->
        <div v-show="qrCodeExpired" style="position: absolute;width: 180px;height: 180px;background-color: rgba(255, 255, 255, 0.95);display: flex;align-items: center;justify-content: center;">
          <div style="width: max-content;height: 40px">
            <div style="font-size: 16px;line-height: 40px;margin-left: 5px">二维码已过期</div>
            <div @click="generateQRCode" style="font-size: 16px;line-height: 40px;margin: 0 auto;width: max-content;color: rgba(25, 118, 210, 1);cursor: pointer">点击刷新</div>
          </div>
        </div>
      </div>
      <div v-show="scanSuccess" style="color:rgba(166, 166, 166, 1);font-size: 14px;margin:30px auto 0 auto;width: fit-content">请在共生地球APP中完成验证</div>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "bindAppDialog",
  mounted() {

  },
  data(){
    return {
      bindAppDialogCtl:false,
      scanSuccess:false,
      qrCodeExpired:false,
    }
  },
  methods:{
    openBindAppDialog(){
      this.bindAppDialogCtl = true
      this.generateQRCode()
    },
    closeBindAppDialog(){
      this.bindAppDialogCtl = false
      clearTimeout(this.isValidTimer)
      clearInterval(this.queryTimer)
    },
    async generateQRCode(){
      // 初始化timer
      this.qrCodeExpired = false
      this.scanSuccess = false
      if(this.queryTimer){
        clearInterval(this.queryTimer)
        this.queryTimer = null
      }
      if(this.isValidTimer){
        clearTimeout(this.isValidTimer)
        this.isValidTimer = null
      }
      // 拉取二维码字符串
      let resultData = await this.$axios.get('/userApi/creator/getQRCodeLogin',{
        params:{'purpose':'bindAPP'}
      })

      let code = {
        'type':'CodeScanType.bindAuthor',
        'content':resultData.data.data
      }
      if(resultData.data.code === 200){
        //清除二维码方法一
        this.$refs.qrCode.innerHTML = '';
        new QRCode(this.$refs.qrCode, {
          //二维码内容
          text: JSON.stringify(code),
          width: 180,
          height: 180,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
      if(resultData.data.code === 200){
        // 轮询APP扫码状态
        this.queryTimer = setInterval(() => {
          this.$axios.get('/userApi/creator/checkQRCodeStatus',{
            params:{
              'QRCode':resultData.data.data
            }
          }).then(
              (resultData)=>{
                if(resultData.data.data.status === 1){
                  this.scanSuccess = true
                  this.qrHintText = '请在共生地球APP中进行确认'
                  clearTimeout(this.isValidTimer)
                }else if(resultData.data.data.status === 2){
                  this.$axios.get('/userApi/creator/bindApp',{
                    params:{
                      "appToken":resultData.data.data.appToken,
                    }
                  }).then(
                      (resultData)=>{
                        clearTimeout(this.isValidTimer)
                        clearInterval(this.queryTimer)
                        this.bindAppDialogCtl = false
                        this.$parent.getUserInfo()
                      }
                  )
                }
              })
        },1000);
        // 设置5分钟后二维码失效
        this.isValidTimer = window.setInterval(() => {
          clearTimeout(this.isValidTimer)
          clearInterval(this.queryTimer)
          this.isValidTimer = null
          this.qrCodeExpired = true
        }, 60*5*1000)
      }
    },
  }
}
</script>

<style scoped>

</style>